// src/components/RetrieveOptionFir.jsx

import React, { useState, useEffect,useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { makeStyles } from "@material-ui/core/styles";

import CustomText from '../../components/CustomText';
import CustomTextInput from '../../components/CustomTextInput';
import CustomButton from '../../components/CustomButton';
import CustomToast from "../../components/CustomToast";
import LoadingOverlay from "../../components/LoadingOverlay";
import CustomBoardNewLogin from '../../components/CustomBoardNewLogin';

import * as selector from "../../../common/selectors";
import * as registrationSelector from "../../../common/selectors";
import * as registrationAction from "../../../common/actions/registration";

import AuthManager from "../../../utils/AuthManager";

import usePrevious from '../../../hooks/usePrevious'; // Adjust the path as necessary
import { Popover } from '@material-ui/core';
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { format, parse, isValid, isBefore,subYears,isAfter } from 'date-fns';
import IconButton from '@material-ui/core/IconButton';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import calendar from '../../../assets/img/calendar.svg';
const useStyles = makeStyles((theme) => ({
  container: {
    paddingTop: "3.5rem",
    paddingLeft: '2.7rem',
    paddingRight: '2.7rem',

    [theme.breakpoints.down('sm')]: {
      paddingTop: "0rem",
      paddingLeft: '0rem',
      paddingRight: '0rem',
      width:"90% !important",
      margin:"auto !important"
    }
  },
  headerTextStyle: {
    fontWeight: 700,
    fontSize: 20,
    textAlign: "left",
    color: "#333333",
    [theme.breakpoints.down('sm')]: {
      fontSize: 18,
    },
  },
  subHeaderText: {
    color: '#797979',
    fontSize: '14px',
    fontWeight: '400',
    marginTop: "0.5rem",
    [theme.breakpoints.down('sm')]: {
      fontSize: '13px',
    },
  },
  labelTextInputTextStyle: {
    fontWeight: 400,
    fontSize: 16,
    color: '#171717',
    [theme.breakpoints.down('sm')]: {
      fontSize: 15,
    },
  },
  textInputContainer: {
    height: 48,
    marginBottom: 25,
    marginTop: 5,
  },
  inputContentContainer: {
    marginTop: 20,
    marginBottom: 5,
  },
  inputContentContainerV1: {
    marginTop: 5,
    marginBottom: 10,
  },
  buttonStyle: {
    height: '47px',
    [theme.breakpoints.down('sm')]: {
      height: '45px',
    },
  },
  backButtonContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    marginTop: '1.5rem',
    color: '#0D99FF',
    textDecoration: 'underline',
  },
  backButtonLink: {
    cursor: 'pointer',
  },
  errorTextStyle:{
    marginTop:'-1.2rem'
  }
  //   textInputContainer: {
  //     height: 48,
  //     marginBottom: 25,
  //     marginTop: 5,
  //     backgroundColor: '#fff',
  //     borderRadius: '4px',
  //     border: 'none',
  // },
}));

const height = 800;
const width = 600;

const RetrieveOptionFir = () => {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();

  // --------------------------
  // Local States
  // --------------------------
  const [nric, setNRIC] = useState('');
  const [customToastStatus, setCustomToastStatus] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [localStatusCode, setLocalStatusCode] = useState(null);
  const [calledApi, setCalledApi] = useState(false);
  const [width, setWidth] = useState(false);
  const [height, setHeight] = useState(false);
  const [dobValue, setDobValue] = useState('');
  const [isDOBValid, setIsDOBValid] = useState(true);
  const [dobTouched, setDobTouched] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  // --------------------------
  // Redux Selectors (new ValidateRegistration flow)
  // --------------------------
  // const registrationReqData = useSelector(selector.registrationReqData);
  // const registrationReqLoading = useSelector(selector.registrationReqLoading);
  const validateRegistrationData = useSelector(registrationSelector.validateRegistrationData);
  const validateRegistrationLoading = useSelector(registrationSelector.validateRegistrationLoading);

  // --------------------------
  // Custom Hook: usePrevious
  // --------------------------
  // const prevRegistrationReqData = usePrevious(registrationReqData);
  const prevValidateRegistrationData = usePrevious(validateRegistrationData);
  const prevDataRef = useRef();
  // --------------------------
  // Handle Redux Response
  // --------------------------
  useEffect(() => {
    AuthManager.removeMobileCountryCode();
    if (calledApi) {
      // Compare current registrationReqData with previous
      if (validateRegistrationData !== prevValidateRegistrationData) {
       // const StatusCode = registrationSelector.registrationStatusCode(validateRegistrationData);
        setLocalStatusCode(validateRegistrationData?.Data?.Status);
      }
    }
  }, [validateRegistrationData]);

  useEffect(() => {
    // If we have a status code and the user already triggered the API
    console.log("prevData",validateRegistrationData)
    if (validateRegistrationData && validateRegistrationData?.Data?.Status !== localStatusCode && calledApi) {
      console.log("Status Code:", localStatusCode, "API Called:", calledApi);
      // Handle different statuses
      switch (localStatusCode) {
        // case 1:
        //   setLocalStatusCode(null);
        //   history.push("/AccountExist");
        //   break;
        // case 2:
        //   // Get data from the store
        //   setLocalStatusCode(null);
        //   const clientMobileNo = registrationSelector.registrationGetMobileNumber(validateRegistrationData);
        //   const otpRefNo = registrationSelector.registrationReference_Number(validateRegistrationData);

        //   AuthManager.setClientMobileNo(clientMobileNo);
        //   AuthManager.setNric(nric);
        //   AuthManager.setOtpReference(otpRefNo);
        //   history.push("/RegistrationOtp");
        //   break;
        // case 3:
        //   setLocalStatusCode(null);
        //   AuthManager.setNric(nric);
        //   history.push("/MobileNoRequired");
        //   break;
        // case 4:
        //   setCustomToastStatus(true);
        //   setToastMessage("Sorry, your request cannot be processed. Please WhatsApp our Customer Care at +65 6887 8777.");
        //   break;
        // case 5:
        //   setCustomToastStatus(true);
        //   setToastMessage("Invalid NRIC/FIN/Passport");
        //   break;
        // case 6:
        //   setLocalStatusCode(null);
        //   const last4Chars = nric.slice(-4);
        //   window.location.href = process.env.REACT_APP_SING_PASS_REG_REDIRECT_URLV2 + `?code=${last4Chars}`;
        //   //passing appId
        //   break;
        // // Added explicit handling for new non-Singpass validation results
        // case 7: // Future-proof in case selector maps 'NRIC' to 7
        //   setLocalStatusCode(null);
        //   AuthManager.setNric(nric);
        //   localStorage.setItem('requireBack', '1');
        //   history.push("/IdentityVerification");
        //   break;
        default:
          // Attempt to derive decision from raw API payload when status code mapping is unavailable
          const rawStatus = validateRegistrationData?.Data?.Status;
          console.log("rawStatus",rawStatus)
          if (rawStatus === "NRIC") {
            AuthManager.setNric(nric);
            localStorage.setItem('requireBack', '1');
            localStorage.setItem('docType','NRIC/FIN');
            
            history.push("/IdentityVerification");
          } else if (rawStatus === "VALIDATION_FAILED") {
            history.push("/OnboardingErr?key=error");
          } else if (rawStatus === "PASSPORT") {
            // Passport behaves like NRIC but only front image required
            AuthManager.setNric(nric);
            localStorage.setItem('requireBack', '0');
            localStorage.setItem('docType','PASSPORT');
            history.push("/IdentityVerification");
          } else if (rawStatus === "NO_CIF") {
            history.push("/OnboardingErr?key=noPolicy");
          } else if (rawStatus === "MULTI_CIF" ) {
            history.push("/OnboardingErr?key=multic");
          }else if(rawStatus === "ACCOUNT_EXISTED"){
            history.push("/ExistingAcc");
          } else if (rawStatus) {
            // Any other status defaults to identity verification as per spec
            AuthManager.setNric(nric);
            localStorage.setItem('requireBack', '0');
            localStorage.setItem('docType','NRIC/FIN');
            history.push("/IdentityVerification");
          } else {
            setCustomToastStatus(true);
            setToastMessage("Sorry, your request cannot be processed. Please WhatsApp our Customer Care at +65 6887 8777.");
          }
      }
    }
    
  }, [validateRegistrationData]);

  // --------------------------
  // Cleanup on Unmount
  // --------------------------
  useEffect(() => {
    setLocalStatusCode(null)
    // 1) Get the entire hash (e.g. "#/RetrieveOptionFir?inapp=1")
    const hash = window.location.hash || "";
    // 2) Find where the query might start (the "?")
    const idx = hash.indexOf("?");

    if (idx !== -1) {
      // 3) Extract the substring from the "?" onward
      //    e.g. "?inapp=1"
      const queryString = hash.substring(idx);

      // 4) Use URLSearchParams to parse the query substring
      const searchParams = new URLSearchParams(queryString);

      // 5) Retrieve 'inapp' from the parsed query
      const inappValue = searchParams.get("inapp");  // e.g. "1"

      // 6) If 'inapp' is "1", do something (e.g. store in localStorage)
      if (inappValue === "1") {
        localStorage.setItem("inapp", "1");
      }

      console.log("inappValue:", inappValue);
    } else {
      // If there's no "?", you might remove it from storage:
      localStorage.removeItem("inapp");
    }

    window.scrollTo(0, 0);
    updateWindowDimensions();
    window.addEventListener("resize", updateWindowDimensions);
    return () => {
      setLocalStatusCode(null);
      setCalledApi(false);
    };

  }, []);

  // --------------------------
  // New ValidateRegistration Request
  // --------------------------
  const handleValidateRegistration = (nric, dob, recaptchaToken) => {
    console.log("Dispatching validate registration with NRIC/DOB:", nric, dob);
    const parsedDate = parse(dob, "dd/MM/yyyy", new Date());
    const formatted = format(parsedDate, "dd MMM yyyy").toUpperCase();
    localStorage.setItem('dobOCR',formatted);
    // Old API commented out
    // dispatch(registrationAction.registrationRequest(nric, recaptchaToken));
    dispatch(registrationAction.validateRegistration({ NRIC: nric, DOB: formatted,RecaptchaToken:recaptchaToken }, recaptchaToken));
  };

  // --------------------------
  // NRIC Change Handler
  // --------------------------
  const onChangeNRIC = (event) => {
    // Only allow alphabets and numbers
    const cleaned = event.target.value.replace(/[^A-Za-z0-9]/g, '');
    setNRIC(cleaned.toUpperCase());
  };
  

  // --------------------------
  // onClickNext Handler
  // --------------------------
  const onClickNext = async () => {
    if (!nric) {
      setCustomToastStatus(true);
      setToastMessage("Please enter your NRIC/FIN/Passport number.");
      return;
    }
    if (!dobValue) {
      setCustomToastStatus(true);
      setToastMessage("Please enter your Date of birth.");
      return;
    }
    if(!isDOBValid){
      setCustomToastStatus(true);
      setToastMessage("Invalid date or future date. Use DD/MM/YYYY.");
      return;
    }
    try {
      // Call reCAPTCHA API to get the token
      const recaptchaToken = await window.grecaptcha.execute(
        "6Lce7OMZAAAAALxOm9WwIETw1EL9UB73SDe4g0Tx",
        { action: "WEB_REGISTRATION_OCR" }
      );

      if (!recaptchaToken) {
        setCustomToastStatus(true)
        setToastMessage("Unable to verify reCAPTCHA. Please try again.")
        return;
      }

      // Update resendOtp state
      setCalledApi(true);
      handleValidateRegistration(nric, dobValue, recaptchaToken);

    } catch (error) {
      setCustomToastStatus(true)
      setToastMessage("Error during reCAPTCHA verification. Please try again.")
    }


  };

  const updateWindowDimensions = () => {
    //this.setState({ width: window.innerWidth, height: window.innerHeight });
    setWidth(window.innerWidth)
    setHeight(window.innerHeight)
  }

  const handleCalendarClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClosePicker = () => {
    setAnchorEl(null);
  };
  const handleDateChange = (date) => {
    if (!date) return;
  
    const newDate = format(date, 'dd/MM/yyyy');
    const oldDate = dobValue;
  
    setDobValue(newDate);
    setIsDOBValid(isBefore(date, new Date()));
    setDobTouched(true);
  
    // ✅ Only close if the *day* is different
    if (oldDate) {
      const newDay = format(date, 'dd'); 
      const oldDay = format(parse(oldDate, 'dd/MM/yyyy', new Date()), 'dd');
  
      if (newDay !== oldDay) {
        handleClosePicker();
      }
    } else {
      // if there was no oldDate, close on the first day selection
      //handleClosePicker();
    }
  };
  

  const handleDOBChange = (raw) => {
    let digits = raw.replace(/\D/g, '').slice(0, 8); // only numbers, max 8
    let display = digits;
  
    if (digits.length >= 5) {
      display = digits.slice(0, 2) + '/' + digits.slice(2, 4) + '/' + digits.slice(4);
    } else if (digits.length >= 3) {
      display = digits.slice(0, 2) + '/' + digits.slice(2);
    }
  
    setDobTouched(true);
    setDobValue(display);
  
    if (digits.length === 8) {
      const dt = parse(display, 'dd/MM/yyyy', new Date());
      const today = new Date();
      const minDOB = subYears(today, 125); // people max 120 years old
  
      const valid =
        isValid(dt) &&
        isBefore(dt, today) &&   // must be before today
        isAfter(dt, minDOB);     // must not be older than 120 years
  
      setIsDOBValid(valid);
    } else {
      setIsDOBValid(false);
    }
  };

  // --------------------------
  // Render Function
  // --------------------------
  const renderPage = () => {
    return (
      <div className={classes.container}>
        <CustomText design={classes.headerTextStyle}>
          Provide your identification below to continue with the registration
        </CustomText>
        {/* <div className={classes.subHeaderText}>
          For customers with NRIC / FIN number, your first time login will be via Singpass only.
        </div> */}

        <div className={classes.inputContentContainer}>
          <CustomTextInput
            title="NRIC/FIN/Passport No."
            textstyle={classes.labelTextInputTextStyle}
            design={classes.textInputContainer}
            fullWidth
            value={nric}
            onChange={onChangeNRIC}
          />
        </div>

        <div className={classes.inputContentContainerV1}>
          <CustomTextInput
            title="Date of birth"
            textstyle={classes.labelTextInputTextStyle}
            design={classes.textInputContainer}
            fullWidth
            value={dobValue}
            onChange={(e) => {
              handleDOBChange(e.target.value);
              //setFormErrors(prev => ({ ...prev, dob: false }));
            }}
            error={(dobTouched && !isDOBValid)}
            errorTextStyle={classes.errorTextStyle}
            errorMessage={!dobValue ? "Please enter your date of birth." : "Invalid date or future date. Use DD/MM/YYYY."}
            placeholder={"DD/MM/YYYY"}
            // disabled={true}
            endAdornment={
              <IconButton onClick={handleCalendarClick}>
                {/* <CalendarTodayIcon /> */}
                <img
                src={calendar}
                className={classes.icon}
              />
              </IconButton>
            }
           // borderline={true}
          />
          <Popover
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            onClose={handleClosePicker}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            transformOrigin={{ vertical: 'top', horizontal: 'center' }}
          >
            <DatePicker
              variant="static"
              format="dd/MM/yyyy"
              label="Date of birth"
              value={dobValue ? parse(dobValue, 'dd/MM/yyyy', new Date()) : null}
              onChange={handleDateChange}
              maxDate={new Date()}
              minDate={new Date(1900, 0, 1)}
            />
          </Popover>
        </div>

        <div style={{ paddingRight: "1em", width: '100%', marginTop: '1rem' }}>
          <CustomButton
            title="Next"
            design={classes.buttonStyle}
            onClick={onClickNext}
          />
        </div>

        <div className={classes.backButtonContainer}>
          <span
            className={classes.backButtonLink}
            onClick={() => history.push("/")}
          >
            Back
          </span>
        </div>
      </div>
    );
  };

  const renderMaintenanceChild = () => {
    return <></>;
  };

  const handleCloseCustomToast = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setCustomToastStatus(false);
  };

  return (
    <>
      <MuiPickersUtilsProvider utils={DateFnsUtils}>

        <CustomBoardNewLogin
          maintenanceChild={renderMaintenanceChild()}
          children={renderPage()}
          height={height}
          width={width}
        />
        <CustomToast
          open={customToastStatus}
          handleCloseCustomToast={handleCloseCustomToast}
          title={toastMessage}
          warning
        />
        {validateRegistrationLoading && (
          <LoadingOverlay loading={true} />
        )}
      </MuiPickersUtilsProvider>

    </>
  );
};

export default RetrieveOptionFir;
